/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1NotificationMobileAppSharedCreateByUser200,
  GetApiV1NotificationMobileAppSharedCreateByUser401,
  GetApiV1NotificationMobileAppSharedCreateByUserQueryParams,
  GetApiV1NotificationMobileAppSharedCreateByUserQueryResponse,
} from "../../types/notificationMobileAppController/GetApiV1NotificationMobileAppSharedCreateByUser.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1NotificationMobileAppSharedCreateByUserQueryParamsSchema =
  z.object({
    searchText: z.optional(z.string()),
    pageNumber: z.coerce.number().int().default(1),
    pageSize: z.coerce.number().int().default(20),
  }) as unknown as ToZod<GetApiV1NotificationMobileAppSharedCreateByUserQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1NotificationMobileAppSharedCreateByUser200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1NotificationMobileAppSharedCreateByUser200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1NotificationMobileAppSharedCreateByUser401Schema =
  z.any() as unknown as ToZod<GetApiV1NotificationMobileAppSharedCreateByUser401>;

export const getApiV1NotificationMobileAppSharedCreateByUserQueryResponseSchema =
  z.lazy(
    () => getApiV1NotificationMobileAppSharedCreateByUser200Schema,
  ) as unknown as ToZod<GetApiV1NotificationMobileAppSharedCreateByUserQueryResponse>;
